import { Tooltip, DefaultWarningButtonIcon, TOOLTIP_SURFACE } from '@repo/atomic-components';
import { useRef, type RefObject } from 'react';

interface UnviewableWarningCellProps {
  reason: string;
}

export const UnviewableWarningCell = ({ reason }: UnviewableWarningCellProps) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const trimmedReason = reason.trim();

  // Icon-only warning, so the text is provided for screen readers only.
  const warningText = trimmedReason ? `File is not viewable. ${trimmedReason}` : 'File is not viewable';

  if (!trimmedReason) {
    return (
      <div className="flex shrink-0 items-center">
        <DefaultWarningButtonIcon width={16} height={16} aria-hidden />
        <span className="sr-only">{warningText}</span>
      </div>
    );
  }

  return (
    <div ref={targetRef} className="flex shrink-0 cursor-pointer items-center">
      <DefaultWarningButtonIcon width={16} height={16} aria-hidden />
      <span className="sr-only">{warningText}</span>
      <Tooltip
        target={targetRef as RefObject<HTMLElement>}
        title="Unable to view file"
        description={trimmedReason}
        position="top"
        className={TOOLTIP_SURFACE}
      />
    </div>
  );
};
